import { render, staticRenderFns } from "./NewsCell.vue?vue&type=template&id=766bd01c&scoped=true"
import script from "./NewsCell.vue?vue&type=script&lang=js"
export * from "./NewsCell.vue?vue&type=script&lang=js"
import style0 from "./NewsCell.vue?vue&type=style&index=0&id=766bd01c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "766bd01c",
  null
  
)

export default component.exports